import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket: any;
  agente_id = null;
  public usuarioEmisor = null;

  constructor(
    private gateway: GatewayService,
    private localsave: LocalSaveService,) {

    this.agente_id = this.localsave.get('usuarioPGV').idagente;
    this.usuarioEmisor = `agente_${this.agente_id}`;
    this.socket = io(this.gateway.globalip, {
      transports: ['websocket']
    });

    this.socket.on("connect", () => {
      // Registrar el usuario
      this.socket.emit("register", `${this.usuarioEmisor}`);
    });

  }

  onNuevaAlarma(callback) {
    this.socket.on("alarma-pendiente", callback);
  }

  onAlarmaTomada(callback) {
    this.socket.on("alarma-tomada", callback);
  }

  tomarAlarma(data) {
    this.socket.emit("tomar-alarma", data);
  }

  enviarRespuesta(usuarioReceptor: any, data: any) {
    this.socket.emit("server-to-user", {
      user_id: usuarioReceptor,
      payload: {
        from: this.usuarioEmisor,
        data: data
      }
    });
  }
}
